import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
export const CurrentSpeedIndicator = ({ speed, }) => {
    const { t } = useTranslation();
    return (_jsx("div", { className: "controller-speed", children: _jsxs("div", { className: "current-speed", children: [_jsx("span", { className: "current-speed-marker", children: t("currentSpeedIndicator.speedUnit") }), speed] }) }));
};
